import React from 'react'
import { Props as LinkProps } from '~/components/Link'
import { Link } from '~/components'
import cn from 'classnames'
import * as st from '~/assets/styl/Button.module.styl'

type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export default function Button({
  href,
  children,
  className,
  outlined,
  ...props
}: (LinkProps | ButtonProps) & { outlined?: boolean; href?: string }) {
  return href ? (
    <Link
      href={href}
      {...(props as LinkProps)}
      className={cn(className, st.core, st.btn, { outlined })}
    >
      <span>{children}</span>
    </Link>
  ) : (
    <button
      {...(props as ButtonProps)}
      className={cn(className, st.core, st.btn, { outlined })}
    >
      <span>{children}</span>
    </button>
  )
}
